import React, { useState, type ReactNode } from 'react'
import type { WorkId } from '../../../../types/WorkId'

export type IAlertContext = {
  error: string
  setError: (error: string) => void
  warning: string
  setWarning: (warning: string) => void
  success: string
  setSuccess: (success: string) => void
  projectQtyErrors: string[]
  setProjectQtyErrors: (workIds: WorkId[]) => void
}

export const AlertContext = React.createContext({} as IAlertContext)

export const AlertContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [error, setError] = useState('')
  const [warning, setWarning] = useState('')
  const [success, setSuccess] = useState('')
  const [projectQtyErrors, setProjectQtyErrors] = useState([] as WorkId[])

  return (
    <AlertContext.Provider
      value={{
        error,
        setError,
        warning,
        setWarning,
        success,
        setSuccess,
        projectQtyErrors,
        setProjectQtyErrors,
      }}
    >
      {children}
    </AlertContext.Provider>
  )
}
